import React, { useState, useEffect, useCallback } from "react";
import { Box, Tabs, Tab, Button, Typography } from "@mui/material";
import PhotoFilterIcon from '@mui/icons-material/PhotoFilter';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import UploadFileUpload from "../Upload/Upload"
import { Image } from "../../services/types"
import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import { Dialog, DialogActions, DialogContent, DialogContentText, IconButton } from '@mui/material';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getModel } from "../../services/apiService";
import CustomForm from "../ModelForm/ModalForm";
import LoaderWithBackdrop from "../Loader/loader";
import { DynamicToastContent, showToast } from '../Toast/CommonToast';
import { toast } from "react-toastify";
import DiamondIcon from '@mui/icons-material/Diamond';
import {
    uploadFile,
    getImagesByModal,
    ModelDetails,
    trainImages,
    getTrainingStatus,
    TrainingInfo,
    getAllAudioDetails, getAudioUpdateDetails
} from "../../services/apiService";
import ReusableButton from "../Reusable/PrimaryButton/PrimaryButton";
import ProgressButton from "../Reusable/ProgressButton/ProgressButton";
import { useCreditPoints } from '../../services/CreditPointsProvider';
// import { useMultipleWebSocket } from "../../context/MultiWebSocket";
import VoicePopup from "../Popup/VoicePopup/VoicePopup";
import VoiceCloneDetails from './VoiceCloneDetails'
import MicIcon from '@mui/icons-material/Mic';
import { useVoiceCloneSocket } from '../../context/VoiceProvider';
import CloseIcon from '@mui/icons-material/Close';
import WhiteButton from "../Reusable/SecondaryButton/SecondaryButton";
import VoiceSelector from "../Studio/VoiceSelector";
import InstructionPopup from "../Popup/VoicePopup/InstructionPopup";



const ShowCaseModalDetails = () => {
    const [images, setImages] = useState<(Image | any)[]>([]);
    const [value, setValue] = React.useState(0);
    const [button, setButton] = React.useState<boolean>(false);
    const [imageContainer, setImageContainer] = React.useState<boolean>(true);
    const userId = localStorage.getItem("userId") || ""
    // const modelId = "123123"
    const { modelId } = useParams();
    const isProd = process.env.REACT_APP_ENV === 'prod';
    const [model, setModel] = useState<any | null>(null);
    const [allTrainings, setAllTrainings] = useState<any | null>(null);
    const [path, setPath] = useState<string>("");
    const [trainingId, setTrainingId] = useState<string | null>(null);
    const [trainingDetails, setTrainingDetails] = useState<any | null>(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [loaderButton, setLoaderButton] = useState(false);
    const [uploadImageLoader, setUploadImageLoader] = useState(false);
    const [trainingStatus, setTrainingStatus] = useState<any | null>(null);
    const isVerified = localStorage.getItem("isVerified");
    const {  fetchCreditPoints } = useCreditPoints();
    const location = useLocation();
    const modelType = location.state?.modelType;
    const navigate = useNavigate();
    const [voiceClone, setVoiceClone] = useState<any>(false);
    const [recording, setRecording] = useState(false);
    const [audioURL, setAudioURL] = useState<string | null>(null);
    const [getAudioDetails, setGetAudioDetails] = useState<any>(null);
    const { responseData } = useVoiceCloneSocket();
    console.log("responseData", responseData)
    const [deleteResponse, setDeleteResponse] = useState<any>(null);
    const pathName = /^\/aipersona\/model\/[^/]+$/.test(location.pathname);
    const [audioSelecting, setAudioSelecting] = useState<boolean>(false);
    const [defaultVoices, setDefaultVoices] = useState<any>(null);
    // VoiceSelector integration state
    const [selectedVoice, setSelectedVoice] = useState<string>("");
    const [voiceDocId, setVoiceDocId] = useState<string>("");
    const [playingVoiceId, setPlayingVoiceId] = useState<string | null>(null);
    const audioRef = React.useRef<HTMLAudioElement | null>(null);
    const [instructionsOpen, setInstructionsOpen] = useState(false);
    // Play/pause logic for voice preview
    const handlePlayPauseVoice = (voice: any) => {
        if (playingVoiceId === voice.voice_id) {
            setPlayingVoiceId(null);
            if (audioRef.current) {
                audioRef.current.pause();
                audioRef.current.currentTime = 0;
            }
        } else {
            setPlayingVoiceId(voice.voice_id);
            const audioUrl = voice.previewUrl || voice.preview_url || voice.sampleAudioUrl || voice.url || voice.previewUrlBlob;
            if (audioUrl) {
                if (audioRef.current) {
                    audioRef.current.pause();
                    audioRef.current.currentTime = 0;
                }
                const audio = new window.Audio(audioUrl);
                audioRef.current = audio;
                audio.play();
                audio.onended = () => setPlayingVoiceId(null);
            } else {
                console.warn('No valid audio URL found for voice:', voice);
            }
        }
    };

    // Selection change logic
    const handleVoiceChange = (voiceId: string, voice?: any) => {
        setSelectedVoice(voiceId);
        setVoiceDocId(voice?._id)
        // You can handle additional logic here if needed
    };
    React.useEffect(()=>{
        console.log("responseData", responseData)
        if(responseData ){
            setGetAudioDetails((prev: any) => ({...responseData, ...prev}))
        }
    },[responseData])

   const getallDetail = useCallback(async()=>{
    try{
        const audioDetails = await getAllAudioDetails()
        console.log("audioDetails", audioDetails)
        setDefaultVoices(audioDetails?.data);    
    }catch(error){
        
        console.error("Error fetching audio details:", error);
    }
   },[])

   console.log("getAudioDetails", getAudioDetails)

   React.useEffect(()=>{
    getallDetail();
   },[])

   const updateVoiceDetails = async ()=>{
    try{ 
        const payload = {
            userId: userId,
            modelId: modelId,
            voiceDocId: voiceDocId
        }
        const updateDetails = await getAudioUpdateDetails(payload);
        setGetAudioDetails(updateDetails?.data);
        setSelectedVoice("")
        setAudioSelecting(false)
    }catch(error){
        console.error("Error updating audio details:", error);
    }
   }







    const handleOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
        setButton(!button)
       if (newValue === 0) {
        setImageContainer(true);
    } else if (newValue !== 2 && newValue === 1) {
        setImageContainer(false);
    }
    };

    useEffect(() => {
        async function getModelDetails() {
            if (modelId) {
                const data: any = await getModel(modelId);
                console.log("dfadsfasdfas", data)
                setModel(data);
                setGetAudioDetails(data?.data?.voiceDetails);
            }
        }

        async function getAllTrainingForModels() {
            if (modelId) {
                const data: any = await ModelDetails(modelId);
                console.log("data", data)
                setAllTrainings(data.data);
            }
        } 
        getModelDetails();
        getAllTrainingForModels();
    }, [modelId, deleteResponse, responseData])

    useEffect(() => {
        if(allTrainings){ 
            setValue(1);
            setImageContainer(false)
        } else {
            setValue(0);
            setImageContainer(true)
        }
        if (allTrainings && allTrainings.length > 0) {
            // Find the latest model
            const latestModel = allTrainings.reduce((latest: any, current: any) =>
                new Date(current.createdAt) > new Date(latest.createdAt)
                    ? current
                    : latest
            );
            setTrainingId(latestModel.trainingId);
            setTrainingStatus(latestModel.trainingRequestStatus);
            setTrainingDetails(latestModel);
            setValue(0);
            setImageContainer(true)
        }
    }, [allTrainings]);

   const getTrainingInfo = useCallback(async () => {
        try {
            if (trainingId) {
                const data = await TrainingInfo(trainingId);
                console.log("data2", data);
                if (data.status === "success") {
                    setPath(data.data.diffusersLoraFileUrl);
                }
            } else {
                console.error("Model ID is undefined");
            }
        } catch (err) {
            console.error("Error fetching models", err);
        }
    }, [trainingId]);

    useEffect(() => {
        const fetchTrainingStatus = async () => {
            try {
                if (!trainingId) {
                    throw new Error("trainingId is required");
                }
                const status = await getTrainingStatus(trainingId);
                if (status.status === "success") {
                    if (status.data.trainingRequestStatus === "COMPLETED") {
                        clearInterval(interval);
                        // showToast("Training complete", "success");
                        setTrainingStatus("COMPLETED");
                        // setShowGenerate(true);
                        getTrainingInfo();
                    } else {
                        // setShowGenerate(false);
                    }
                    // setTrainingStatus(status.data);
                }
                // setTrainingStatus(status);
                // setError(null); // Clear previous errors if the call succeeds
            } catch (err: any) {
                // setError(err.message || "An error occurred while fetching training status.");
            }
        };

        // Fetch the status initially
        fetchTrainingStatus();

        // Set up polling every 5 minutes
        const interval = setInterval(fetchTrainingStatus, 1 * 60 * 1000);

        // Cleanup on component unmount
        return () => clearInterval(interval);
    }, [trainingId,getTrainingInfo]);

    //file Upload
    const handleFileUpload = async (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        const files = event.target.files;
        setUploadImageLoader(true)
    
        if (files) {
            // 50MB size limit per file
            const MAX_SIZE = 50 * 1024 * 1024; // 50MB in bytes
            for (let file of Array.from(files)) {
                if (file.size > MAX_SIZE) {
                    showToast(`File ${file.name} exceeds 50MB limit. Please select smaller files.`, "error");
                    setUploadImageLoader(false);
                    return;
                }
            }
            const formData = new FormData();
            Array.from(files).forEach((file, index) => {
                // Remove whitespace from the file name
                const newFile = new File(
                    [file],
                    file.name.replace(/\s+/g, "_"),
                    { type: file.type }
                );
                formData.append("files", newFile);
            });
            if (modelId) formData.append("modelId", modelId);
            formData.append("userId", userId || "");
            // formData.append("isShowcaseImage", "true");
    
            try {
                const uploadFileResponse = await uploadFile(formData);
    
                if (uploadFileResponse.status === "success") {
                    const newImages = uploadFileResponse.data;
                    showToast("Files uploaded successfully", "success");
                    setImages((prev: any) => [...prev, ...newImages]);
                    setTrainingStatus("");
                    setUploadImageLoader(false)
                } else {
                    showToast("Error uploading files", "error");
                    console.error("Error uploading files", uploadFileResponse);
                    setUploadImageLoader(false)
                }
            } catch (error:any) {
                console.error("Error uploading files", error);
                showToast(error?.message, "error");
                setUploadImageLoader(false)
            } finally {
                // console.log("File upload complete");
                setUploadImageLoader(false)
            }
        } else {
            console.error("No files selected");
            setUploadImageLoader(false)
        }
    };

    // Use optional chaining to avoid error if location.state is null
    const modelTypes: any = location.state?.modelType;
    //modal details
    useEffect(() => {
        const getImagesByModalId = async () => {
            try {
                if (modelId) {
                    const data: any = await getImagesByModal(modelId);
                    console.log("data1", data);
                    if (data.status === "success") {
                        if (data.data.length > 0) {
                            setImages(data.data);
                        }
                    }
                } else {
                    console.error("Model ID is undefined");
                }
            } catch (err) {
                console.error("Error fetching models", err);
            }
        };
        getImagesByModalId();
    }, [modelId, modelTypes])


    const handleConfirmTrain = async () => {
        setLoaderButton(true);
        handleCloseDialog();
        if (!modelId) {
            throw new Error("modelId is required");
        }
        const imagesInfo = images.map((image) => ({
            id: image._id,
            url: image.url,
            caption: image.caption,
        }));
    
        const trainData = {
            userId,
            modelId,
            imagesInfo,
        };
        try {
            if (!modelId) {
                throw new Error("modelId is required");
            }
            const trainResponse = await trainImages(trainData);    
 
            setLoaderButton(false);
            if (trainResponse.status === "success") {
                setLoaderButton(false);
                setTrainingId(trainResponse.data.trainingId);
                setTrainingStatus(trainResponse.data.status);
                await fetchCreditPoints(userId);
            }

        }
        catch (err: any) {
            console.log(err.status)
            console.log(err.message)
            if(err.status === 402 
                || err.statusCode === 402 || err.statusCode === 403 || err.statusCode === 404
                || err.status === 404 || err?.status === 403){
                setLoaderButton(false);
                localStorage.setItem("redirectLocation", location.pathname);
                const toastContent = (
                    <DynamicToastContent
                        icon={DiamondIcon}
                        message={err.message}
                        actionText="Buy Credits"
                        onActionClick={() => {
                            navigate("/subscription");
                            toast.dismiss();
                        }}
                    />
                );
    
                toast(toastContent, {
                    autoClose: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: false,
                });
            }
            else{
                showToast("An unexpected error occurred", "error");
                console.error("Error training images", err);
            }
        }
    };  

    //breadcrumb
    // const dynamicRouteLabels = {
    //     "/": "Home",
    //     "/persona": "Showcase",
    //    [`/persona/model/${modelId}`]: model?.data?.name || "Model",
    // }

    console.log('getAudioDetails', getAudioDetails)
      
    return (
        <>

            <LoaderWithBackdrop open={uploadImageLoader} /> 
            <div className="showCaseAddModelContainer">
                {/* <Box>
                    <Breadcrumb routeLabels={dynamicRouteLabels}/>
                </Box> */}
                <Box sx={{ display: "flex", flexDirection: "row", padding: "0px 0px 0px 10px", gap: "10px", alignItems: "center", margin: '5px 0px', width: '100%' }}>
                    <Box>
                        <PermIdentityIcon sx={styles.iconbutton} />
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", gap: '10px', width: '25%'}}>
                        <Typography variant="h6" sx={styles.modalName}>
                            {model?.data?.name}
                        </Typography>
                    </Box>
                    {/* <Box>
                    <Button variant="contained" sx={styles.logoutButton}>
                        Superman
                    </Button>
                </Box> */}
                </Box>
                <div className="gradient-background" style={styles.container}>
                    <Box sx={styles.tabsContainer}>
                        <Box>
                            <Tabs
                                value={value}
                                onChange={handleChange}
                                textColor="inherit"
                                indicatorColor="primary"
                                sx={styles.tabs}
                            >
                                <Tab label="Generate" icon={<AutoAwesomeIcon sx={{ display: 'flex' }} />} sx={styles.tab} />
                                <Tab label="Images for Training" icon={<PhotoFilterIcon sx={{ display: "flex" }} />} sx={styles.tab} />
                                {(getAudioDetails && (getAudioDetails?.sampleAudioUrl || getAudioDetails?.url || getAudioDetails?.preview_url)) && (
                                    <Tab label={!pathName ? "Clone Voice" : "Voice Details"} icon={<PhotoFilterIcon sx={{ display: "flex" }} />} sx={styles.tab} />
                                )}
                            </Tabs>
                        </Box>
                        <div style={{ display: "flex", justifyContent: "space-between" , alignItems: "center" , gap: '10px'}}>
                            {/* {value !== 0 && <p style={{ marginRight: "10px" }}>{trainingStatus === "COMPLETED" ? "Completed" : trainingStatus === "IN_PROGRESS" ? "In Progress" : trainingStatus}</p>} */}
                            {!pathName ? (
                            <ReusableButton
                            icon={<MicIcon  />}
                            onClick={() => setInstructionsOpen(true)}
                            disabled={getAudioDetails?.sampleAudioUrl ? true : false}
                            >
                                Add Voice (450 credits)
                            </ReusableButton>):(
                                <ReusableButton 
                                onClick={() => setAudioSelecting(true)}
                                disabled={getAudioDetails?.preview_url ? true : false}
                                >
                                    Select AI Voice
                                </ReusableButton>
                            )}
                            {images.length > 0 && value !== 0 && (
                                <Box sx={styles.buttonmain}
                                >
                                   {( (value !== 0 && loaderButton) || trainingStatus === "IN_PROGRESS" ) ? (
                                    <ProgressButton trainingStatus = {trainingStatus}/>
                                ) : (
                                    <ReusableButton
                                      disabled={
                                        !isProd ||
                                        isVerified === 'false' ||
                                        (
                                          images.length > 0 &&
                                          images.every(img => String(img.trainingStatus).toLowerCase() === 'trained')
                                        )
                                      }
                                      onClick={handleOpenDialog}
                                      icon={<SettingsSuggestIcon sx={styles.icon} />}
                                    >
                                        <Typography variant="body1" sx={styles.traintext}>
                                            Train (1500 Credits)
                                        </Typography>
                                    </ReusableButton>
                                   )}
                                </Box>
                            )}
                          
                        </div>
                        {instructionsOpen && (
                            <InstructionPopup
                            open={instructionsOpen}
                            onClose={() => setInstructionsOpen(false)}
                            onContinue={() => {
                                setInstructionsOpen(false);
                                setVoiceClone(true);
                            }}
                             instructions={[
    "Use headphones with a mic in a quiet space for clear audio and minimal echo.",
    "Click Record and speak clearly and naturally for clear voice output.",
    "Ensure you have enough credits before starting"
  ]}
                            />
                        )}
                        {voiceClone && (
                                         <VoicePopup
              open={voiceClone}
              onClose={() => setVoiceClone(false)}
              setRecording={setRecording}
              setAudioURL={setAudioURL}
              audioURL={audioURL}
              recording={recording}
              onSubmit={(data: { audioURL: string }) => {
                console.log("data.audioURL", data.audioURL, audioURL)
                setAudioURL(data.audioURL);
              }}
              modelName={model?.data?.name}
              
            />
                        )}
                    </Box>
                    <div >
                       {value === 0 && (
    <CustomForm
        modelId={modelId}
        path={path}
        trainingId={trainingId}
        trainingDetails={trainingDetails}
        allTrainings={allTrainings}
    />
)}
{value === 1 && (
    <UploadFileUpload
        handleFileUpload={handleFileUpload}
        images={images}
        modelType={modelType}
        setImages={setImages}
        modelId={modelId}
    />
)}
{value === 2 && (
    <VoiceCloneDetails
        modalName= {model}
        getAudioDetails={getAudioDetails}
        setDeleteResponse={setDeleteResponse}
    />
)}

                    </div>
                </div>
                <Dialog
                    open={openDialog}
                    onClose={handleCloseDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    PaperProps={{
                        sx: {
                            backgroundColor: '#282C4D',
                            color: '#fff', // Change text color for contrast
                        },
                    }}
                >
                    {/* <DialogTitle id="alert-dialog-title">Confirm Training</DialogTitle> */}
                    <DialogContent style={{ padding: "40px" }}>
                        <DialogContentText style={{ color: "white" }} id="alert-dialog-description">
                            Training will cost 1500 credits and will take around 35 minutes. Do you want to proceed?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions style={{ padding: "20px" }}>
                        <ReusableButton onClick={handleConfirmTrain} color="primary">
                            Continue
                        </ReusableButton>
                        <Button sx={styles.buttonCancel} onClick={handleCloseDialog} color="primary" autoFocus>
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
                {audioSelecting &&(
                    <Dialog
                        open={audioSelecting}
                        onClose={() => setAudioSelecting(false)}
                        aria-labelledby="select-audio-dialog-title"
                        aria-describedby="select-audio-dialog-description"
                        fullWidth
                        PaperProps={{
                            sx: {
                                backgroundColor: '#282C4D',
                                color: '#fff', 
                            },
                        }}
                    >
                        <IconButton onClick={() => setAudioSelecting(false)} className="PopupCloseButton" sx={{ position: 'absolute', right: 8, top: 8 }}>
                            <CloseIcon />
                        </IconButton>
                        <DialogContent style={{ padding: "40px" }}>
                            <DialogContentText style={{ color: "white", marginBottom: 2}} id="select-audio-dialog-description">
                                Audio Selection
                            </DialogContentText>
                            <VoiceSelector
                                voices={defaultVoices || []}
                                handlePlayPauseVoice={handlePlayPauseVoice}
                                playingVoiceId={playingVoiceId}
                                selectedVoice={selectedVoice}
                                onVoiceChange={handleVoiceChange}
                            />
                        </DialogContent>
                        <DialogActions style={{ padding: "20px" }}>
                            <WhiteButton onClick={() => setAudioSelecting(false)} color="primary">
                                cancel
                            </WhiteButton>
                            <ReusableButton onClick={() => updateVoiceDetails()} color="primary">
                                Submit
                            </ReusableButton>
                        </DialogActions>
                    </Dialog>
                )}


            </div>
        </>

    );
}
export default ShowCaseModalDetails;


const styles = {
    container: {
        // backgroundColor: '#1D1C34',
        height: '100vh',
    },
    tabsContainer: {
        flexGrow: 1,
        Margin: "0px auto",
        Padding: '0px 30px',
        borderBottom: "1px solid #565A78",
        display: 'flex',
        justifyContent: 'space-between',
    },
    tabs: {
        "&.MuiTabs-flexContainer": { borderBottom: "2px solid #565A78" },
        "& .MuiTabs-indicator": {
            border: "1.5px solid #fff",
        },
        "& .MuiTabs-flexContainer": {
            minHeight: "60px",
        },
    },
    tab: {
        color: "#fff", fontSize: "15px", textTransform: 'Capitalize', fontWeight: 600, fontFamily: 'var(--font-family-primary)', height: '50px',
        "&.MuiButtonBase-root": {
            minHeight: "60px",
            display: 'flex',
            flexDirection: 'row',
            gap: '5px',
            textTransform: 'none',
            
        }
    },
    buttonmain: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginRight: "30px",
    },
    buttonContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#69319D",
         color:"#FDFCFF",
        borderRadius: "10px",
        padding: "10px 26px",
        textTransform: "none",
        width: "100%",
    },
    buttonCancel: {
        backgroundColor: "#1C2340",
        color: "#9E9E9E",
        textTransform: 'none'
    },
    icon: {
        fontSize: 24, marginRight: "8px"
    },
    traintext: {
        fontWeight: 400, fontFamily: 'var(--font-family-primary)', fontSize: '15px'
    },
    logoutButton: {
        backgroundColor: '#3F3589',

        color: '#FFFFFF',
        borderRadius: '10px',
        textTransform: 'none',
        padding: '8px 20px',
        fontSize: '10px',
        fontWeight: 600,
        width: '100%',
        fontFamily: 'var(--font-family-primary)',
    },
    modalName: {
        color: "#fff",
        fontSize: "24px",
        fontWeight: 400,
        fontFamily: 'var(--font-family-primary)',
    },
    iconbutton: {
        color: "#fff",
        display: 'flex'
    }

}